//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import TransferBetweenWarehouseModel from '@/models/Warehouse/WhTransferBetweenWarehouse'
import Translator from '@/services/translator'
import fields from './fields'
import validate from 'validate.js'

//
export default {
    name: 'dispatch-requests-update',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),

        /**
         *
         */
        formProps() {
            return {
                fields: fields({
                    g_branch_office_id: this.branchOfficeId,
                    triggerWarehouse: this.changeWarehouseFilter,
                }),
            }
        },
    },
    data() {
        return {
            branchOfficeId: 1,
            formData: {
                wh_selected_products: [],
            },
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        changeWarehouseFilter(ctx) {
            this.branchOfficeId =
                ctx.getInput('of_warehouse').getSelected().g_branch_office_id ||
                this.user.hr_employee.g_branch_office_id
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'transfer-between-warehouse' })
        },

        /**
         *
         */
        reset() {
            this.branchOfficeId = this.user.hr_employee.g_branch_office_id
            this.formData = new TransferBetweenWarehouseModel()
            this.formData.g_to_supervisor_id = this.user.id
        },

        /**
         *
         */
        showError(error) {
            //console.log({ error })
            this.showSnackbar(
                'error',
                'Error.',
                Translator(TransferBetweenWarehouseModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Guía de intercambio creada.',
                this.redirect
            )
        },

        /**
         *
         */
        submit(event) {
            if (event.wh_from_warehouse_id !== event.wh_to_warehouse_id) {
                this.$refs.form.setWait(true).then(this.create)
            } else {
                this.showSnackbar(
                    'error',
                    'Advertencia.',
                    'Las bodegas deben ser distintas.'
                )
            }
        },

        /**
         *
         */
        create(model) {
            Promise
                .resolve(model)
                .then(this.toCreate)
                .then(this.showSuccess)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },

        toCreate(model) {
            return model.create()
        }
    },
    watch: {
        'formData.wh_selected_products'(value) {
            if (value.length > 24) {
                this.formData.wh_selected_products = value.slice(0, 24)
            }
        },
    },
    beforeMount() {
        this.setTitleTopBar('Crear guía de intercambio')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_TRANSFER_BETWEEN_WAREHOUSE'))
                ctx.$router.push('/')
        })
    },
}
